import { Component } from 'react';
import { getYears, DEFAULT_YEAR } from './keys';
import ManualClusterSelect from '../../../components/manualClusterModal';

class ExtraButtons extends Component {
    constructor() {
        super();

        this.years = getYears();
    }

    render() {
        const { t } = this.props;

        return (
            <div className="table-additional-view">
                <div className="table-additional-view-btns">
                    <div className="table-additional-view-btn-groups">
                        {this.years.map((item) => {
                            const activeYear = this.props.year ?? DEFAULT_YEAR;
                            return (
                                <button
                                    className={`${activeYear === item.value && 'active'}`}
                                    key={item.value}
                                    onClick={() => this.props.getData(item.value)}
                                    disabled={activeYear === item.value}
                                >
                                    {item.label}
                                </button>
                            );
                        })}
                    </div>
                </div>
                <ManualClusterSelect
                    current_url={this.props.endpoint_url}
                    csrf_token={this.props.csrf_token}
                    selectedItems={this.props.selectedItems}
                    header={t('search.year_keywords.clusters_header')}
                    cluster_type="keyword"
                    onRemoveAllSelected={this.props.onRemoveAllSelected}
                />
            </div>
        );
    }
}

export default ExtraButtons;
